import { useThree, useFrame } from "@react-three/fiber";

// Wächter für die occlude="blending"-Labels (Annotation.jsx & Co.).
//
// Hintergrund: dreis <Html> fasst beim Mounten GLOBALE Canvas-Styles an
// (drei/web/Html.js, useLayoutEffect[occlude]): mit occlude="blending"
// setzt es zIndex/position/pointerEvents auf dem Canvas — darauf beruhen
// die runden, korrekt im 3D-Raum verdeckten Labels. JEDE Html OHNE
// occlude (ThemeMonitor, VideoWallSingle, Tourismus-Videos, PicIcons …)
// RESETTET diese Styles beim Mounten wieder auf null. Danach fallen alle
// Labels auf flache DOM-Overlays zurück: eckig, ohne 3D-Verdeckung, nur
// aus einer Perspektive lesbar (z.B. nach Click→Player→Click→Player oder
// beim Holzarbeit-Timemachine-Slider).
//
// Statt jeden Verursacher einzeln zu patchen, stellt dieser Guard die
// Blending-Styles pro Frame wieder her, sobald sie abweichen (billiger
// String-Vergleich). '1' = floor(zIndexRange[0]=2 / 2), wie es die
// Annotations setzen. Die App läuft praktisch immer mit aktivem Blending
// (Labels sind allgegenwärtig) — diesen Zustand dauerhaft zu erzwingen
// ist also der Normalfall, kein Sonderverhalten.
export default function HtmlBlendingGuard() {
  const gl = useThree((state) => state.gl);

  useFrame(() => {
    const el = gl.domElement;
    if (el.style.zIndex !== "1") {
      el.style.zIndex = "1";
      el.style.position = "absolute";
      el.style.pointerEvents = "none";
    }
  });

  return null;
}
